module.exports = __webpack_public_path__ + "01426582745a3bd67c30996b8ad36c51.MP3";